import colorPresets from '../constants/colorPresets';
import { habitFill, isHexColor } from '../utils/colorUtils';

// Shared gradient-swatch picker. Used by the settings modal's add/edit forms
// and the first-run starter-habits modal. The swatch ring is sized so the
// selected and unselected states stay the same overall size (border-2 on
// both, transparent when unselected).
function GradientColorPicker({ value, onChange, className = '' }) {
  return (
    <div className={`flex flex-wrap ${className}`}>
      {colorPresets.map((preset) => (
        <button
          key={preset.name}
          type="button"
          onClick={() => onChange(preset.gradient)}
          aria-label={preset.name}
          aria-pressed={value === preset.gradient}
          className={`w-8 h-8 rounded-full bg-gradient-to-br ${preset.gradient} shadow-sm mr-2 mb-2 border-2 transition-transform hover:scale-110 ${
            value === preset.gradient ? 'border-[var(--color-ink-main)] scale-110' : 'border-transparent'
          }`}
        />
      ))}
      {/* A color mixed on the native app's wheel is not one of the ten. Show
          it as the selected eleventh swatch so editing here does not look
          like the habit has no color; picking a preset replaces it. */}
      {isHexColor(value) && (
        <button
          type="button"
          onClick={() => onChange(value)}
          aria-label={`Custom color ${value}`}
          aria-pressed="true"
          className="w-8 h-8 rounded-full shadow-sm mr-2 mb-2 border-2 border-[var(--color-ink-main)] scale-110"
          style={habitFill(value).style}
        />
      )}
    </div>
  );
}

export default GradientColorPicker;
